<ul  class="dropdown-attributes-types bz--unselectable"
    style="display: block; height: auto; overflow-y: auto;"
    [style.max-height]="300">
    <li #container *ngFor="let node of nodes; let i = index">
        <treeview-node 
            [node]="node" 
            (nodeSelected)="onNodeSelected($event)"
            (itemSelected) = "onEmitCheck($event)">
        </treeview-node>        
    </li>
</ul>

